import type { BloodType } from '../realtime/contracts';

export const BLOOD_TYPE_LABELS: Record<BloodType, string | undefined> = {
  Unknown: undefined,
  ZeroNegative: '0−',
  ZeroPositive: '0+',
  ANegative: 'A−',
  APositive: 'A+',
  BNegative: 'B−',
  BPositive: 'B+',
  ABNegative: 'AB−',
  ABPositive: 'AB+',
  ZeroUnknown: '0',
  AUnknown: 'A',
  BUnknown: 'B',
  ABUnknown: 'AB',
  HH: 'HH',
};
